import { snakeCase } from "lodash"

const convertCamelToSnakeCase = data => Object.keys(data).reduce((acc, key) => {

  const snakedKey = snakeCase(key)
        
  acc[snakedKey] = data[key]

  /**
   * If the accumulator value is an object it should recurse down to ensure that all children are updated as well
   */
  if (acc[snakedKey] && typeof acc[snakedKey] === "object" && !Array.isArray(acc[snakedKey])) {
    acc[snakedKey] = convertCamelToSnakeCase(acc[snakedKey])
  }
  return acc
}, {})

export default convertCamelToSnakeCase